module.exports = __webpack_public_path__ + "img/the-mover-hover.bfaa4da1.png";